import { css } from 'lit';
/* eslint-disable promise/prefer-await-to-then */
/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { HttpStatusCode } from '@constants';
import { APIRequestReturn } from '../../redux/APIRequest';
import store, { ThunkActionRoot } from '../../redux/redux-store';
import { getREMEventImports } from '../../redux/rem/rem-actions-event';

//	get all event imports

let EventImportsPollingTimeout: ReturnType<typeof setInterval>;
let EventImportsLastAPIRequestReturn: APIRequestReturn;

function EventImportsPollingVisibilityChangeHandler() {
	if (!document.hidden) {
		// eslint-disable-next-line promise/prefer-await-to-then
		void store.dispatch(getREMEventImports()).then((ret) => {
			EventImportsLastAPIRequestReturn = ret;
			return ret;
		});
	}
}
export const stopPollingEventImports = (autoAbort = true): void => {
	window.clearInterval(EventImportsPollingTimeout);
	if (autoAbort && EventImportsLastAPIRequestReturn) {
		EventImportsLastAPIRequestReturn.abortController?.abort();
	}
	document.removeEventListener('visibilitychange', EventImportsPollingVisibilityChangeHandler);
};

const POLLING_DELAY_PADDING_MS = 2000;

export const startPollingEventImports =
	(pollingDelayMs: number, pollImmediately = true): ThunkActionRoot<Promise<void>> =>
	async (dispatch, getState): Promise<void> => {
		const { eventsLastPolled } = getState().rem;

		if (
			pollImmediately ||
			!eventsLastPolled ||
			Date.now() - eventsLastPolled - POLLING_DELAY_PADDING_MS > pollingDelayMs
		) {
			EventImportsLastAPIRequestReturn = await dispatch(getREMEventImports());
		}
		window.clearInterval(EventImportsPollingTimeout);

		// eslint-disable-next-line @typescript-eslint/no-misused-promises
		EventImportsPollingTimeout = setInterval(async (): Promise<void> => {
			EventImportsLastAPIRequestReturn = await dispatch(getREMEventImports());
			if (EventImportsLastAPIRequestReturn.response?.status === HttpStatusCode.UNAUTHORIZED) {
				stopPollingEventImports();
			}
		}, pollingDelayMs);
		document.addEventListener('visibilitychange', EventImportsPollingVisibilityChangeHandler);
	};


